import { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: JSX.Element;
  redirectPath?: string;
}

//To-Do: Add user groups validation so we can check if the user has the correct role to access the route

export default function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element | null {
  const { user, loading } = useAuth();

  if (loading) {
    // Loading state while Auth is being checked
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-proposio-purple"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login if user is not authenticated
    return <Navigate to={'/login'} replace />;
  }
  // Render the children if authenticated
  return children;
}
